import React, { useRef, useEffect } from 'react';

//import MDSpinner from "react-md-spinner";

const ChatBox = (props) => {
  
  const { chat, chatIsLoading, selectedCustomer, containerRef, tabIndex } = props;

  useEffect(() => {
    containerRef && containerRef.current && containerRef.current.focus();
  });
    
  //let focusedMessage = {...chat[chat.length-1], focus: containerRef, tabIndex: -1};
  //chat[chat.length-1] = focusedMessage;
  //console.log(chat);
  if (chatIsLoading) {
    return (
      <div className="col-xl-12 my-auto text-center">
        <span className="spinner-border spinner-border-sm"></span>
      </div>
    );
  } else {
    return (
      (chat && chat.length && selectedCustomer) ? <div className="col-xl-12">
        {chat.map((chat, i) => (
          <div key={i} className="message" 
          ref={chat[i] === chat[chat.length-1] && containerRef}
          tabIndex={chat[i] === chat[chat.length-1] && tabIndex}>
            <div                
              className={`${
                chat.sender ? "balon2" : "balon1"
              } p-3 m-1`}
            >
              {chat.message}
              
            </div>
          </div>
        ))}
      </div> : null
    );
  }

}
export default ChatBox;